module.exports = __webpack_public_path__ + "static/img/logo-white.4bff34a.png";